const filterAdapters = {
  status: {
    field: 'hc_status',
    path: 'work_order__hired_candidate'
  },
  vendor_name: {
    field: 'wo_vendor_name',
    path: 'work_order'
  }
}

export default filterAdapters
